
import React, { useState, useRef, useEffect } from "react";
import Input from "../../../../../Components/Input";
import Dropdown from "../../../../../Components/Dropdown";
import MobileInput from "../../../../../Components/MobileInput";
import editIcon from '../../../../../Assets/Icons/edit.png'
import deleteIcon from '../../../../../Assets/Icons/delete.png';
import filterIcon from '../../../../../Assets/Icons/filter.png'
import leftBtuIcon from '../../../../../Assets/Icons/back.png'
import SMSContactController from "../../../../Controllers/AdminScreens/Configuration/ContactsCenter/SMSContactController";
import ConfigurationEmailConfigurationModal from "../../../../../Components/Modals/ConfigurationEmailConfigurationModal";
import ConfigurationAddNewContactModal from "../../../../../Components/Modals/ConfigurationAddNewContactModal";
import Loader from "../../../../../Components/Loader";
import { convertGMTToLocal } from "../../../../../Utils/Validation";
import downArrow from '../../../../../Assets/Icons/chevron-down.png';
import DeleteConfirmationModal from '../../../../../Components/Modals/DeleteConformationModal'

const SMSContactList = ({ setSmsList, smsList, smsError, setSmsError, setSmsLoading, smsLoading, onRefresh, handleRefreshAllTabs }) => {

  const {
    filterData,
    setFilterData,
    emailContactData,
    handleInputChange,
    handlePageChange,
    currentPage,
    currentContacts,
    totalPages,
    setSelectedDocument,
    selectedDocument,
    fetchFilterSmsList,
    resetFilters,
    setWhatsAppFilterErrror,
    whatsAppFilterError,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    isDeleteModalOpen,
    setIsDeleteModalOpen,
    handleDelete,
    deletedMessages,
    deleteContactSuccess,
    deleteContactError,
    deleteContactLoading,
    callDeleteWhatsAppContact,
    currentContacteDeleteIndex,
    handleFileChange,
    handleButtonClick,
    fileInputRef,
    bulkContactsUploadError,
    bulkContactsUploadSuccess,
    bulkContactsUploadLoading,
    importMasterTemplatesLoading,
    importMasterTemplateError,
    handleImportMasterTemplates
  } = SMSContactController(setSmsList, smsList, setSmsError, smsError, setSmsLoading, smsLoading, onRefresh, handleRefreshAllTabs);

  const [showFilters, setShowFilters] = useState(false);
  const toggleFilters = () => {
    onRefresh();
    setShowFilters(!showFilters);
    resetFilters()
  };

  const showFilter = () => {
    setShowFilters(!showFilters);
  }

  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleEditDocument = (contact) => {
    setSelectedDocument(contact);
    setIsModalOpen(true);
  };
  const [isAddContactModalOpen, setIsAddContactModalOpen] = useState(false);

  const [userPermissions, setUserPermissions] = useState(null);
  useEffect(() => {
    const storedUserInfo = JSON.parse(localStorage.getItem('_userInfo_'));
    setUserPermissions(storedUserInfo?.user_permissions || {});
  }, [])

  const handleSMSConfiguration = () => {
    setIsModalOpen(true); // Open the modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const handleAddContactModal = () => {
    setIsAddContactModalOpen(true)
  }

  const handleAddContactCloseModal = () => {
    setIsAddContactModalOpen(false)
  }
  const [openDropdown, setOpenDropdown] = useState(null); // Tracks the currently open dropdown
  const toggleDropdown = (dropdownName) => {
    setOpenDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const dropdownRefs = useRef({}); // Ref for dropdown

  // Handle clicks outside dropdowns
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isOutside = Object.keys(dropdownRefs.current).every(
        (key) => dropdownRefs.current[key] && !dropdownRefs.current[key].contains(event.target)
      );
      if (isOutside) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const maxVisiblePages = 3;

  const getVisiblePages = () => {
    const startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    // Adjust startPage if we're near the end
    const adjustedStartPage = Math.max(1, endPage - maxVisiblePages + 1);

    return Array.from({ length: endPage - adjustedStartPage + 1 }, (_, index) => adjustedStartPage + index);
  };

  const visiblePages = getVisiblePages();

  return (
    <>
      <div className='basic-info-container'>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <h3 style={styles.categoryHeader}>SMS Contacts</h3>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <div style={{ display: 'flex', marginBottom: '10px' }}>
              <button
                className="add-client-button"
                style={{ paddingLeft: 30, paddingRight: 30, marginRight: '15px' }}
                onClick={handleSMSConfiguration}
              >
                Add Contact
              </button>

              <div style={{ position: 'relative' }}>
                <button
                  className="cancel-button"
                  style={{
                    border: '1px var(--button-bg-color) solid',
                    borderRadius: '20px',
                    paddingLeft: '30px',
                    paddingRight: '30px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minWidth: '150px'
                  }}
                  onClick={handleButtonClick}
                >
                  <span>Upload Contacts</span>
                  {bulkContactsUploadLoading && (
                    <Loader loading={true} color={'var(--primary-loader-color)'} size="small" />
                  )}
                </button>

                <input
                  type="file"
                  accept=".xlsx, .xls"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  style={{ display: 'none' }}
                />
              </div>
              <button
                className="add-client-button"
                style={{ paddingLeft: 30, paddingRight: 30, marginLeft: '15px' }}
                onClick={handleImportMasterTemplates}
              >
                <span>Download Sample</span>
                {importMasterTemplatesLoading && (
                  <Loader loading={true} color={'var(--background-color)'} size="small" />
                )}
              </button>
            </div>

            {bulkContactsUploadError && (
              <div className="list-error-msg" >
                {bulkContactsUploadError}
              </div>
            )}
            {importMasterTemplateError && (
              <div className="list-error-msg" >
                {importMasterTemplateError}
              </div>
            )}
            {bulkContactsUploadSuccess && (
              <div className="list-success-msg">
                {bulkContactsUploadSuccess}
              </div>
            )}
          </div>
        </div>
        <div style={styles.container}>
          <div style={styles.filtersHeader}>
            <button style={styles.filterButton} onClick={showFilter}> <img src={filterIcon} style={styles.filterIcon} /> Filters</button>
            <div>
              <img src={leftBtuIcon} style={{ marginRight: '5px', cursor: 'pointer', width: '28px', height: '28px' }} />
              <img src={leftBtuIcon} style={{ transform: 'rotate(180deg)', transition: 'transform 0.3s ease', cursor: 'pointer', width: '28px', height: '28px' }} />
            </div>
          </div>
        </div>
        {/* Filters using Flexbox */}
        {showFilters && (
          <div >
            <div className="tasksScreen-filters-flex">
              <div className="filter-field">
                <Input
                  label="Contact Name"
                  placeholder="Contact Name"
                  value={filterData?.contactName}
                  onChange={(e) => handleInputChange('contactName', e.target.value)}
                />
              </div>
              {/* <Input
                label="Phone No."
                placeholder="Phone No."
                value={filterData?.phoneNo}
                onChange={(e) => handleInputChange('phoneNo', e.target.value)}
              /> */}
              <div className="filter-field">
                <MobileInput
                  label="Phone No."
                  countryCode={filterData?.countryCode}
                  mobileNumber={filterData?.phoneNo}
                  onMobileChange={(value) => handleInputChange('phoneNo', value)}
                  onCountryChange={(value) => handleInputChange('countryCode', value)}
                  placeholder="Enter mobile number"
                  countries={[
                    { code: "IN", dialCode: "+91" },
                    { code: "US", dialCode: "+1" },
                    { code: "UK", dialCode: "+44" },
                  ]}
                />
              </div>
              <div className="filter-field">
                <Dropdown
                  ref={(el) => (dropdownRefs.current[" "] = el)}
                  isOpen={openDropdown === " "}
                  toggleDropdown={() => toggleDropdown(" ")}
                  label="Otp Out"
                  options={["Yes", "No"]}
                  placeholder="Otp Out"
                  value={filterData?.optOut}
                  onChange={(value) => handleInputChange('optOut', value)}
                  searchBoxWidth={190}
                />
              </div>
            </div>
            <div className="button-container" style={{ marginBottom: '15px' }}>
              <button
                onClick={fetchFilterSmsList}
                className="tasksScreen-apply-button"
                style={{
                  cursor: smsLoading ? "not-allowed" : "pointer",
                  opacity: smsLoading ? 0.6 : 1,
                  pointerEvents: smsLoading ? 'none' : 'auto',
                  gap: '5px',
                  display: 'flex'
                }}
                disabled={smsLoading}
              >
                {smsLoading && (
                  <Loader loading={smsLoading} color={'var(--background-color)'} size="small" />
                )}
                <span>Apply</span>
              </button>
              <button className="cancel-button" style={{ border: '1px var(--button-bg-color) solid', borderRadius: '20px', marginLeft: '10px' }} onClick={resetFilters}>Cancel</button>
              <button className="cancel-button" onClick={toggleFilters}>Reset</button>
              {whatsAppFilterError && <div className="list-error-msg">{whatsAppFilterError} </div>}
            </div>
          </div>
        )}
      </div>

      <div className='basic-info-card' style={{ border: 'none', padding: '0px' }}>
        <div style={styles.tableWrapper}>
          <table className="tasksScreen-task-table">
            <thead>
              <tr>
                <th style={{ width: "20%" }}>Contact Name</th>
                <th style={{ width: "20%" }}>Contact No.</th>
                <th style={{ width: "15%" }}>List Name</th>
                <th style={{ width: "15%" }}>Added On</th>
                <th style={{ width: "15%" }}>Added By</th>
                <th style={{ width: "10%" }}>Opt Out</th>
                <th style={{ width: "5%" }}></th>
              </tr>
            </thead>
            <tbody style={{ backgroundColor: "white" }}>
              {currentContacts?.map((contact, index) => (
                <tr key={index}>
                  <td style={styles.tableValue}>{contact?.contact_name}</td>
                  <td style={styles.tableValue}>{contact?.contact_no}</td>
                  <td style={styles.tableValue}>{contact?.list_name}</td>
                  <td style={styles.tableValue}>{contact?.created_at ? convertGMTToLocal(contact?.created_at, 'dd/MM/yyyy') : '--'}</td>
                  <td style={styles.tableValue}>{contact?.emp_name}</td>
                  <td style={styles.tableValue}>{contact?.opt_out == 1 ? 'Yes' : 'No'}
                    {deleteContactSuccess && currentContacteDeleteIndex === index &&
                      <div style={{ color: 'green', textDecoration: 'none' }}>{deleteContactSuccess}</div>}
                    {deleteContactError && currentContacteDeleteIndex === index &&
                      <div style={{ color: 'red', textDecoration: 'none' }}>{deleteContactError}</div>}
                  </td>
                  <td>
                    <div
                      style={{
                        display: "flex",
                        gap: "2px", // Space between edit and delete buttons
                      }}
                    >
                      {/* Edit Button */}
                      {userPermissions?.config?.per_name_sub_json?.cont_center_edit === 1 &&
                        <button
                          className="tasksScreen-edit-button"
                          style={{
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                          }}
                        >
                          <img
                            src={editIcon}
                            alt="Edit"
                            style={{ width: "16px", height: "16px" }}
                            onClick={() => handleEditDocument(contact)}
                          />
                        </button>
                      }

                      {/* Delete Button */}
                      {userPermissions?.config?.per_name_sub_json?.cont_center__delete === 1 &&
                        <button
                          className="tasksScreen-delete-button"
                          style={{
                            border: "none",
                            background: "transparent",
                            cursor: "pointer",
                          }}
                        >
                          <img
                            src={deleteIcon}
                            alt="Delete"
                            style={{ width: "16px", height: "16px" }}
                            onClick={() => { handleDelete(contact, index) }}
                          />
                        </button>
                      }
                      {deleteContactLoading && currentContacteDeleteIndex === index && (
                        <span style={{ marginLeft: '5px' }}>
                          <Loader loading={deleteContactLoading} color={'var(--primary-loader-color)'} size="small" />
                        </span>
                      )}
                    </div>
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
          {smsError && <div className="list-error-msg">{smsError} </div>}
          {smsLoading && <Loader loading={smsLoading} color={'var(--primary-loader-color)'} />}
        </div>
        <div className="tasksScreen-table-footer">
          <span className="tasksScreen-pagination-info">
            {`${currentPage}-${totalPages} of items`}
          </span>
          <div className="tasksScreen-pagination">
            <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1 || totalPages === 0}>
              <img src={downArrow} alt="Previous" className="tasksScreen-arrow-left tasksScreen-icon-image " />
            </button>
            {/* {[...Array(totalPages)].map((_, index) => (
                        <button key={index} className={`tasksScreen-pagination-button ${currentPage === index + 1 ? 'active' : ''}`} onClick={() => handlePageChange(index + 1)}>{index + 1}</button>
                    ))} */}
            {/* Page Numbers */}
            {visiblePages.map((page) => (
              <button
                key={page}
                className={`tasksScreen-pagination-button ${currentPage === page ? "active" : ""}`}
                onClick={() => handlePageChange(page)}
              >
                {page}
              </button>
            ))}
            <button className="tasksScreen-pagination-button" onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages || totalPages === 0}>
              <img src={downArrow} alt="Next" className="tasksScreen-arrow-right tasksScreen-icon-image " />
            </button>
          </div>
        </div>
        {isModalOpen && (
          <ConfigurationAddNewContactModal isOpen={isModalOpen} onClose={handleCloseModal} onRefresh={onRefresh} channelType="SMS" documentData={selectedDocument} setSelectedDocument={setSelectedDocument} handleRefreshAllTabs={handleRefreshAllTabs} />
        )}
        <DeleteConfirmationModal
          isOpen={isDeleteModalOpen}
          message={`Are you sure you want to delete ${selectedDocument?.contact?.contact_name}?`}
          onClose={handleCloseDeleteModal}
          onConfirm={() => {
            handleCloseDeleteModal(); // Close modal
            callDeleteWhatsAppContact()
          }}
        />
        {/* {isAddContactModalOpen && (
          <ConfigurationAddNewContactModal isOpen={isAddContactModalOpen} onClose={handleAddContactCloseModal} />
        )} */}
      </div>
      {/* <hr className="divider" style={{ marginTop: '20px' }} /> */}
    </>
  )

}

const styles = {
  categoryHeader: {
    color: '#1F384C',
    fontSize: 18,
    fontFamily: 'Roboto Slab',
    fontWeight: 500,
    paddingBottom: 20
  },
  tableWrapper: {
    overflowX: "auto", // Horizontal scroll
    whiteSpace: "nowrap", // Prevent table from wrapping on small devices
    // marginBottom:50
  },
  tableValue: {
    colour: '#192A3E',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px'
  },
  tableLink: {
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: '12px',
    textDecoration: 'underline',
    color: '#5A55D2'
  },
  container: {
    padding: "5px",
    backgroundColor: "#EFF0F4",
    border: "none",
    // borderRadius: "5px",
    border: '1px #EFF0F4 solid'
  },
  filtersHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // marginBottom: "15px",
  },
  filterButton: {
    backgroundColor: "white",
    color: "var(--button-bg-color)",
    border: "none",
    borderRadius: "5px",
    padding: "5px 8px",
    cursor: "pointer",
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    border: '1px var(--button-bg-color) solid'

  },
  filterIcon: {
    width: '10px',
    height: '10px',
    paddingRight: '5px'
  },

  paginationButtons: {
    display: "flex",
    gap: "5px",
  },
  paginationButton: {
    backgroundColor: "#fff",
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "5px 10px",
    cursor: "pointer",
  },
  filtersContainer: {
    // display: "flex",
    flexWrap: "wrap", // Wrap inputs to the next line if needed
    gap: "20px", // Space between inputs
    marginBottom: "15px",
    // justifyContent: "space-between", // Distribute inputs evenly
    border: '1px #EFF0F4 solid',
    padding: '10px'
  },
  buttonsContainer: {
    display: "flex",
    gap: "10px",
    alignItems: "center",
  },
  applyButton: {
    backgroundColor: "var(--button-bg-color)",
    color: "var(--button-text-color)",
    border: "none",
    borderRadius: "5px",
    padding: "8px 15px",
    cursor: "pointer",
  },
  cancelButton: {
    backgroundColor: "transparent",
    border: "1px solid #ccc",
    borderRadius: "5px",
    padding: "8px 15px",
    cursor: "pointer",
  },
  resetButton: {
    backgroundColor: "transparent",
    color: "#555",
    border: "none",
    cursor: "pointer",
  },
  labaleStyle: {
    fontSize: '12px',
    // marginBottom: '5px',
    fontWeight: '400',
    fontFamily: 'Roboto',
    color: 'rgb(52, 60, 68)'
  },


}

export default SMSContactList